import { useSystem } from "../../../hooks/use-system";
import { Button } from "../../../components/UI/button";
import IPBanner from "../../../components/IPBanner";
import nordLandingImage from "../../../assets/images/nord-landing.png";
import tickImage from "../../../assets/images/tick.png";
import grayTickImage from "../../../assets/images/gray-tick.png";
import wifiPasswordImage from "../../../assets/images/wifi_password.png";
import distanceImage from "../../../assets/images/distance.png";
import rocketLaunchImage from "../../../assets/images/rocket_launch.png";
import languageImage from "../../../assets/images/language.png";
import devicesImage from "../../../assets/images/devices.png";
import visibilityOffImage from "../../../assets/images/visibility_off.png";
import femaleLifestyleImage from "../../../assets/images/female-lifestyle-adult.png";
import fiCheckImage from "../../../assets/images/fi_check.png";
import starsImage from "../../../assets/images/stars.png";
import usdImage from "../../../assets/images/usd.png";
import greenWhiteImage from "../../../assets/images/green-white.png";
import maleImage from "../../../assets/images/male.png";
import male1Image from "../../../assets/images/male1.png";
import female1Image from "../../../assets/images/female1.png";
import female2Image from "../../../assets/images/female2.png";
import male2Image from "../../../assets/images/male2.png";
import female3Image from "../../../assets/images/female3.png";
import nordFeaturedImage from "../../../assets/images/nord/nord_featured.png";
import fmNord2 from "../../../assets/images/fm-nord2.png";
import heroCircularImage from "../../../assets/images/nord-image1.png";
import { useState, useEffect } from "react";
import landingPageNordBg from "../../../config/landing-page-nord-bg";
import landingPageNordEn from "../../../config/landing-page-nord-en";

const FaqItem = ({ item, isOpen, onClick }) => {
    return (
        <div className="border-b py-4" style={{borderColor: "#BABABA"}}>
            <button onClick={onClick} className="w-full text-left flex justify-between items-start">
                <span className={`text-lg ${isOpen ? 'font-semibold' : 'font-normal'}`}>{item.question}</span>
                <div className="flex-shrink-0 ml-4">
                    {isOpen ? (
                        <svg className="w-6 h-6" style={{color: "#3E5EFF"}} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>
                    ) : (
                        <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                    )}
                </div>
            </button>
            {isOpen && (
                <div className="mt-4 text-gray-600 text-left">
                    <p className="lg:text-lg">{item.answer}</p>
                </div>
            )}
        </div>
    );
};

export default function LandingStep({ setShowLanding }) {
    const { config } = useSystem();
    const [openFaqItems, setOpenFaqItems] = useState([0]);
    const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

    const handleClick = () => {
        window.scrollTo(0, 0);
        setShowLanding(false);
    };

    const handleFaqClick = (index) => {
        setOpenFaqItems(prev => 
            prev.includes(index) 
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };

    // Get the language from supported_languages config and select the appropriate text config
    const language = config?.supported_languages && Object.keys(config.supported_languages)[0];
    const textConfig = language === 'bu' ? landingPageNordBg : landingPageNordEn;

    useEffect(() => {
        const testimonials = textConfig?.trusted?.testimonials;
        if (testimonials && testimonials.length > 0) {
            const interval = setInterval(() => {
                setCurrentTestimonialIndex(prevIndex => (prevIndex + 1) % testimonials.length);
            }, 6000);

            return () => clearInterval(interval);
        }
    }, [textConfig]);

    if (!config) {
        return null; 
    }

    const testimonialAvatars = {
        male: maleImage,
        male1: male1Image,
        male2: male2Image,
        female1: female1Image,
        female2: female2Image,
        female3: female3Image
    };

    return (
        <div className="min-h-screen bg-white w-full overflow-x-hidden pb-16 lg:pb-0">
            <IPBanner />

            {/* Header with Logo */}
            <div className="w-full shadow-md mb-4">
                <div className="flex items-center justify-center py-3 lg:justify-start lg:max-w-6xl lg:mx-auto lg:px-6 lg:py-4">
                    <img
                        src={config.logo_url}
                        alt="NordVPN Logo"
                        className="w-auto h-8 landscape:h-auto landscape:max-w-[150px] lg:h-8"
                    />
                </div>
            </div>

            {/* --- Main Content --- */}
            <div className="lg:flex lg:items-center lg:justify-between lg:max-w-6xl lg:mx-auto lg:px-6 lg:pt-12 lg:gap-x-12">
                {/* Left side: Text content */}
                <div className="mx-auto px-6 text-center lg:text-left lg:mx-0 lg:px-0 lg:w-7/12">
                    <h1 className="text-2xl font-semibold leading-tight mb-2 lg:text-[40px] lg:font-semibold lg:text-left" dangerouslySetInnerHTML={{ __html: textConfig.hero.title.replace(/\n/g, '<br />') }}>
                    </h1>

                    {/* Mobile-only layout */}
                    <div className="lg:hidden">
                        <p className="text-gray-600 mb-4" dangerouslySetInnerHTML={{ __html: textConfig.hero.subtitle.replace(/\n/g, '<br />') }}></p>
                        <div className="flex items-center justify-center mb-3">
                            <img src={greenWhiteImage} alt="Checkmark" className="h-4 w-4 mr-2" />
                            <span className="font-bold">{textConfig.hero.noCardRequired}</span>
                        </div>
                        <div className="flex justify-center">
                            <Button
                                onClick={handleClick}
                                className="flex justify-center items-center gap-2.5 text-white font-semibold text-xl mb-3 rounded-full w-full max-w-[330px] h-[60px] px-8 sm:px-[55px] py-[18px]"
                                style={{ backgroundColor: "#E02F1F", fontFamily: "Inter, sans-serif", lineHeight: "120%" }}
                            >
                                {textConfig.hero.primaryButton}
                            </Button>
                        </div>
                        <div className="flex items-center justify-center mb-8">
                            <img src={grayTickImage} alt="Checkmark" className="h-4 w-4 mr-2" />
                            <span className="text-gray-500 text-xs">{textConfig.hero.moneyBackGuarantee}</span>
                        </div>
                    </div>

                    {/* Desktop-only layout */}
                    <div className="hidden lg:block">
                        <p className="text-gray-600 text-base text-left pr-24 mb-12" dangerouslySetInnerHTML={{ __html: textConfig.hero.subtitle.replace(/\n/g, '<br />') }}></p>
                        <div className="flex justify-start">
                             <Button
                                onClick={handleClick}
                                className="flex justify-center items-center gap-2.5 text-white font-semibold text-xl rounded-full w-[240px] h-[60px]"
                                style={{ backgroundColor: "#E02F1F", fontFamily: "Inter, sans-serif", lineHeight: "120%" }}
                            >
                                {textConfig.hero.primaryButton}
                            </Button>
                        </div>
                        <div className="flex gap-x-12 mt-12">
                            <div>
                                <div className="text-5xl font-semibold">7500+</div>
                                <div className="text-[#666666] text-xl font-semibold">{textConfig.stats.vpnServers}</div>
                            </div>
                            <div>
                                <div className="text-5xl font-semibold">14M+</div>
                                <div className="text-[#666666] text-xl font-semibold">{textConfig.stats.usersWorldwide}</div>
                            </div>
                            <div>
                                <div className="text-5xl font-semibold">118</div>
                                <div className="text-[#666666] text-xl font-semibold">{textConfig.stats.countries}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right side: Image */}
                <div className="lg:w-7/12">
                    {/* Mobile Image */}
                    <div className="w-full lg:hidden">
                        <img
                            src={nordLandingImage}
                            alt="People using devices"
                            className="w-full h-auto block landscape:max-w-xl landscape:mx-auto"
                        />
                    </div>
                    {/* Desktop Image */}
                    <div className="hidden lg:block relative overflow-hidden">
                        <img
                            src={heroCircularImage}
                            alt="People using devices"
                            className="w-full h-auto transform scale-110 -translate-y-2 origin-center"
                        />
                    </div>
                </div>
            </div>

            {/* Mobile Stats */}
            <div className="max-w-md mx-auto px-6 text-center lg:hidden">
                <div className="grid grid-cols-3 gap-4 text-center mb-8 mt-6">
                    <div>
                        <div className="text-3xl font-semibold" style={{fontWeight: 600}}>7500+</div>
                        <div className="text-gray-500 font-semibold" style={{fontSize: '14px', fontWeight: 600}}>{textConfig.stats.vpnServers}</div>
                    </div>
                    <div>
                        <div className="text-3xl font-semibold" style={{fontWeight: 600}}>14M+</div>
                        <div className="text-gray-500 font-semibold" style={{fontSize: '14px', fontWeight: 600}}>{textConfig.stats.usersWorldwide}</div>
                    </div>
                    <div>
                        <div className="text-3xl font-semibold" style={{fontWeight: 600}}>118</div>
                        <div className="text-gray-500 font-semibold" style={{fontSize: '14px', fontWeight: 600}}>{textConfig.stats.countries}</div>
                    </div>
                </div>
            </div>

            {/* Why Us Section */}
            <div className="max-w-md mx-auto px-6 text-center py-12 lg:max-w-6xl lg:pt-40">
                <h3 className="text-blue-600 font-semibold text-lg mb-2 lg:text-2xl">{textConfig.whyUs.sectionTitle}</h3>
                <h2 className="text-2xl font-semibold mb-4 lg:leading-tight lg:text-[40px]" dangerouslySetInnerHTML={{ __html: textConfig.whyUs.title }}></h2>
                <p className="text-gray-600 mb-8">
                    {textConfig.whyUs.subtitle}
                </p>

                <div className="grid grid-cols-2 gap-4 mb-8 lg:mb-12 lg:mt-12 lg:flex lg:flex-row lg:gap-4">
                    {/* Feature 1: Online Security */}
                    <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center min-h-40 lg:flex-1">
                        <img src={wifiPasswordImage} alt="Online Security" className="h-14 w-14 mb-4" />
                        <span className="font-semibold text-base text-center">{textConfig.whyUs.features.onlineSecurity}</span>
                    </div>

                    {/* Feature 2: Hide Your IP */}
                    <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center min-h-40 lg:flex-1">
                        <img src={distanceImage} alt="Hide Your IP" className="h-14 w-14 mb-4" />
                        <span className="font-semibold text-base text-center">{textConfig.whyUs.features.hideYourIp}</span>
                    </div>

                    {/* Feature 3: Fastest VPN */}
                    <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center min-h-40 lg:flex-1">
                        <img src={rocketLaunchImage} alt="Fastest VPN" className="h-14 w-14 mb-4" />
                        <span className="font-semibold text-base text-center">{textConfig.whyUs.features.fastestVpn}</span>
                    </div>

                    {/* Feature 4: Global Coverage */}
                    <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center min-h-40 lg:flex-1">
                        <img src={languageImage} alt="Global Coverage" className="h-14 w-14 mb-4" />
                        <span className="font-semibold text-base text-center">{textConfig.whyUs.features.globalCoverage}</span>
                    </div>

                    {/* Feature 5: Multiple Devices */}
                    <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center min-h-40 lg:flex-1">
                        <img src={devicesImage} alt="Multiple Devices" className="h-14 w-14 mb-4" />
                        <span className="font-semibold text-base text-center">{textConfig.whyUs.features.multipleDevices}</span>
                    </div>

                    {/* Feature 6: No User Tracking */}
                    <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center min-h-40 lg:flex-1">
                        <img src={visibilityOffImage} alt="No User Tracking" className="h-14 w-14 mb-4" />
                        <span className="font-semibold text-base text-center">{textConfig.whyUs.features.noUserTracking}</span>
                    </div>
                </div>

                <Button
                    onClick={handleClick}
                    className="flex justify-center items-center gap-2.5 text-white font-semibold text-xl rounded-full w-full max-w-[330px] h-[60px] px-8 sm:px-[55px] py-[18px] lg:w-[259px] lg:h-[60px]"
                    style={{ 
                        backgroundColor: "#E02F1F",
                        fontFamily: "Inter, sans-serif",
                        lineHeight: "120%"
                    }}
                >
                    {textConfig.whyUs.button}
                </Button>
            </div>

            {/* Trusted Section */}
            <div className="py-16" style={{backgroundColor: "#E2F1FF"}}>
                <div className="max-w-md mx-auto px-6 text-center lg:max-w-6xl">
                    <h3 className="text-blue-600 font-semibold text-lg mb-2">{textConfig.trusted.sectionTitle}</h3>
                    <h2 className="text-2xl font-semibold mb-6 lg:text-[40px] lg:leading-tight" dangerouslySetInnerHTML={{ __html: textConfig.trusted.title }}></h2>

                    {/* User Avatars */}
                    <div className="flex justify-center items-center mb-10">
                        <img src={male1Image} alt="User 1" className="rounded-full flex-shrink-0 h-[77px] w-[77px] lg:h-[100px] lg:w-[100px]" />
                        <img src={female1Image} alt="User 2" className="rounded-full -ml-6 flex-shrink-0 h-[77px] w-[77px] lg:h-[100px] lg:w-[100px]" />
                        <img src={female2Image} alt="User 3" className="rounded-full -ml-6 flex-shrink-0 h-[77px] w-[77px] lg:h-[100px] lg:w-[100px]" />
                        <img src={male2Image} alt="User 4" className="rounded-full -ml-6 flex-shrink-0 h-[77px] w-[77px] lg:h-[100px] lg:w-[100px]" />
                        <img src={female3Image} alt="User 5" className="rounded-full -ml-6 flex-shrink-0 h-[77px] w-[77px] lg:h-[100px] lg:w-[100px]" />
                        <div className="rounded-full -ml-6 flex-shrink-0 h-[77px] w-[77px] bg-blue-600 flex items-center justify-center text-white font-bold text-lg lg:h-[100px] lg:w-[100px] lg:text-[25px] lg:font-semibold">
                            14M+
                        </div>
                    </div>

                    {/* Testimonials */}
                    {/* Desktop View */}
                    <div className="hidden lg:grid lg:grid-cols-3 lg:gap-8 mb-8">
                        {textConfig.trusted.testimonials.map((testimonial, index) => (
                            <div key={index} className="bg-white rounded-xl p-6 text-left" style={{ border: '1px solid #3E5FFF40', boxShadow: '0px 0px 8px 0px #3E5FFF40' }}>
                                <div className="flex items-center mb-4">
                                    <img src={testimonialAvatars[testimonial.avatar]} alt={testimonial.name} className="w-12 h-12 rounded-full mr-4" />
                                    <div>
                                        <div className="font-bold">{testimonial.name}</div>
                                        <div className="text-gray-500">{testimonial.handle}</div>
                                    </div>
                                </div>
                                <p className="text-gray-600" dangerouslySetInnerHTML={{ __html: testimonial.text }}></p>
                            </div>
                        ))}
                    </div>
                        
                    {/* Mobile View */}
                    <div className="lg:hidden bg-white rounded-xl shadow-lg p-6 max-w-lg mx-auto mb-8 text-left min-h-[400px]">
                        <div className="flex items-center mb-4">
                            <img src={testimonialAvatars[textConfig.trusted.testimonials[currentTestimonialIndex].avatar]} alt={textConfig.trusted.testimonials[currentTestimonialIndex].name} className="w-12 h-12 rounded-full mr-4" />
                            <div>
                                <div className="font-bold">{textConfig.trusted.testimonials[currentTestimonialIndex].name}</div>
                                <div className="text-gray-500">{textConfig.trusted.testimonials[currentTestimonialIndex].handle}</div>
                            </div>
                        </div>
                        <p className="text-gray-600" dangerouslySetInnerHTML={{ __html: textConfig.trusted.testimonials[currentTestimonialIndex].text }}></p>
                    </div>

                    {/* Slider - Mobile Only */}
                    <div className="lg:hidden flex justify-center items-center mb-8">
                        <div className="w-full h-0.5 bg-white rounded-full relative">
                            <div
                                className="w-1/3 h-0.5 bg-blue-600 rounded-full absolute top-0 transition-all duration-500 ease-in-out"
                                style={{ left: `${(currentTestimonialIndex * 100) / 3}%` }}
                            ></div>
                        </div>
                    </div>

                    <Button
                        onClick={handleClick}
                        className="flex justify-center items-center gap-2.5 text-white font-semibold text-xl rounded-full w-full max-w-[330px] h-[60px] px-8 sm:px-[55px] py-[18px] lg:w-[242px] lg:h-[60px]"
                        style={{ 
                            backgroundColor: "#E02F1F",
                            fontFamily: "Inter, sans-serif",
                            lineHeight: "120%"
                        }}
                    >
                        {textConfig.trusted.button}
                    </Button>
                </div>
            </div>

            {/* How to use section */}
            <div className="bg-white py-16">
                <div className="max-w-md mx-auto px-6 text-center lg:max-w-6xl">
                    <h3 className="text-blue-600 font-semibold text-lg lg:text-xl mb-2">{textConfig.howToUse.sectionTitle}</h3>
                    <h2 className="text-2xl font-semibold mb-4 lg:text-[40px]">{textConfig.howToUse.title}</h2>
                    <p className="text-gray-600 mb-8">{textConfig.howToUse.subtitle}</p>

                    <div className="space-y-8 lg:space-y-0 lg:flex lg:items-stretch lg:justify-between lg:relative lg:mb-12 mb-8">
                        
                        <div className="hidden lg:block absolute top-1/2 left-0 w-full h-px bg-gray-200" style={{ transform: 'translateY(-50%)', zIndex: 0 }}></div>

                        {/* Step 1 */}
                        <div className="border border-gray-200 rounded-2xl py-6 px-8 text-left lg:flex-1 lg:max-w-[calc(33.333%-1.5rem)] bg-white relative z-10">
                            <div className="mb-4">
                                <span className="text-blue-600 font-bold text-lg">01</span>
                                <div className="w-8 h-0.5 bg-blue-600 mt-1"></div>
                            </div>
                            <h4 className="font-semibold text-lg mb-2">{textConfig.howToUse.steps.step1.title}</h4>
                            <p className="text-gray-600" dangerouslySetInnerHTML={{ __html: textConfig.howToUse.steps.step1.description }}></p>
                        </div>

                        {/* Step 2 */}
                        <div className="border border-gray-200 rounded-2xl py-6 px-8 text-left lg:flex-1 lg:max-w-[calc(33.333%-1.5rem)] bg-white relative z-10">
                            <div className="mb-4">
                                <span className="text-blue-600 font-bold text-lg">02</span>
                                <div className="w-8 h-0.5 bg-blue-600 mt-1"></div>
                            </div>
                            <h4 className="font-semibold text-lg mb-2">{textConfig.howToUse.steps.step2.title}</h4>
                            <p className="text-gray-600" dangerouslySetInnerHTML={{ __html: textConfig.howToUse.steps.step2.description }}></p>
                        </div>

                        {/* Step 3 */}
                        <div className="border border-gray-200 rounded-2xl py-6 px-8 text-left lg:flex-1 lg:max-w-[calc(33.333%-1.5rem)] bg-white relative z-10">
                            <div className="mb-4">
                                <span className="text-blue-600 font-bold text-lg">03</span>
                                <div className="w-8 h-0.5 bg-blue-600 mt-1"></div>
                            </div>
                            <h4 className="font-semibold text-lg mb-2">{textConfig.howToUse.steps.step3.title}</h4>
                            <p className="text-gray-600" dangerouslySetInnerHTML={{ __html: textConfig.howToUse.steps.step3.description }}></p>
                        </div>
                    </div>
                    
                    <Button
                        onClick={handleClick}
                        className="flex justify-center items-center gap-2.5 text-white font-semibold text-xl rounded-full w-full max-w-[330px] h-[60px] px-8 sm:px-[55px] py-[18px] lg:w-[242px] lg:h-[60px]"
                        style={{ 
                            backgroundColor: "#E02F1F",
                            fontFamily: "Inter, sans-serif",
                            lineHeight: "120%"
                        }}
                    >
                        {textConfig.howToUse.button}
                    </Button>
                </div>
            </div>

            {/* Pricing Section */}
            <div className="py-16" style={{backgroundColor: "#E2F1FF"}}>
                <div className="max-w-lg mx-auto px-6 text-center">
                    <h3 className="text-blue-600 font-semibold text-lg lg:text-xl mb-2">{textConfig.pricing.sectionTitle}</h3>
                    <h2 className="text-2xl font-semibold lg:text-[40px] lg:leading-tight mb-4">{textConfig.pricing.title}</h2>
                </div>
                <div className="max-w-lg mx-auto px-6 text-center lg:max-w-6xl">
                    <p className="text-gray-600 mb-8 lg:text-black lg:text-[18px]" dangerouslySetInnerHTML={{ __html: textConfig.pricing.subtitle }}></p>
                </div>
                <div className="max-w-lg mx-auto px-6 text-center">

                    <div className="rounded-2xl overflow-hidden border-1 lg:shadow-[0px_0px_20px_0px_#3E5FFF40]" style={{borderColor: "#3E5FFF"}}>
                        {/* Card Header */}
                        <div className="bg-blue-600 text-white font-bold py-3">
                            {textConfig.pricing.planName}
                        </div>

                        {/* Card Body */}
                        <div className="bg-white p-8">
                            <div className="mb-6 text-left">
                                <span className="text-4xl font-bold">{textConfig.pricing.price}</span>
                                <span className="text-gray-600">{textConfig.pricing.priceUnit}</span>
                                <p className="text-gray-500 text-sm mt-1">{textConfig.pricing.vatNotice}</p>
                            </div>

                            <ul className="space-y-4 text-left mb-8 list-none pl-0">
                                {textConfig.pricing.features.map((feature, index) => (
                                    <li key={index} className="flex items-start">
                                        <img src={fiCheckImage} alt="check" className="h-5 w-5 mr-3 mt-0.5" />
                                        <span className="text-gray-500">{feature}</span>
                                    </li>
                                ))}
                            </ul>

                            <div className="flex justify-center">
                                <Button
                                    onClick={handleClick}
                                    className="flex justify-center items-center text-white font-semibold text-xl rounded-full w-full h-[60px] py-3 lg:w-[349px] lg:h-[60px]"
                                    style={{ 
                                        backgroundColor: "#E02F1F",
                                        fontFamily: "Inter, sans-serif",
                                        lineHeight: "120%"
                                    }}
                                >
                                    {textConfig.pricing.button}
                                </Button>
                            </div>

                            <div className="mt-6 space-y-3">
                                <div className="flex items-center justify-center">
                                    <img src={usdImage} alt="usd" className="h-6 w-5 mr-2" />
                                    <span className="text-xs text-gray-700 font-bold">{textConfig.pricing.guarantees.moneyBack}</span>
                                </div>
                                <div className="flex items-center justify-center">
                                    <img src={greenWhiteImage} alt="green-white" className="h-4 w-4 mr-2" />

                                    <span className="text-xs text-gray-700 font-bold">{textConfig.pricing.guarantees.noCard}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Hassle-free setup Section */}
            <div className="bg-white pt-28 pb-16 px-6">
                <div className="max-w-md mx-auto bg-[#E2F1FF] rounded-2xl px-8 py-12 text-left lg:max-w-7xl lg:px-12 lg:py-28 relative lg:rounded-[40px]">
                    {/* Content that defines container height */}
                    <div className="lg:w-1/2">
                        <h2 className="text-2xl font-semibold mb-4 leading-tight lg:text-[40px]">{textConfig.hassleFree.title}</h2>
                        <p className="mb-6 text-gray-600 text-base lg:text-lg">
                            {textConfig.hassleFree.subtitle}
                        </p>
                        
                        <div className="relative lg:hidden">
                            <img src={femaleLifestyleImage} alt="Person using a phone" className="mx-auto" />
                        </div>

                        <Button
                            onClick={handleClick}
                            className="flex justify-center items-center gap-2.5 text-white font-semibold text-xl rounded-full w-full h-auto min-h-[60px] px-8 sm:px-[65px] py-[6px] lg:w-[325px] lg:h-[60px] lg:mt-4"
                            style={{ 
                                backgroundColor: "#E02F1F",
                                fontFamily: "Inter, sans-serif",
                                lineHeight: "120%"
                            }}
                        >
                            <span className="text-center">{textConfig.hassleFree.button}</span>
                        </Button>
                    </div>

                    {/* Absolutely positioned desktop image */}
                    <div className="hidden lg:block absolute bottom-0 right-11 w-[37%]">
                        <img src={fmNord2} alt="Hassle free" className="w-full h-auto" />
                    </div>
                </div>
            </div>

            {/* FAQ Section */}
            <div className="bg-white py-16">
                <div className="max-w-md mx-auto px-6 lg:max-w-6xl">
                    <div className="text-center mb-10">
                        <h3 className="text-blue-600 lg:text-xl font-semibold mb-2">{textConfig.faq.sectionTitle}</h3>
                        <h2 className="text-2xl lg:text-[40px] font-semibold whitespace-wrap">{textConfig.faq.title}</h2>
                    </div>

                    <div className="border-t" style={{borderColor: "#BABABA"}}>
                        {textConfig.faq.questions.map((item, index) => (
                            <FaqItem
                                key={index}
                                item={item}
                                isOpen={openFaqItems.includes(index)}
                                onClick={() => handleFaqClick(index)}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* Footer Section */}
            <div className="bg-white py-16">
                <div className="max-w-md mx-auto px-6 flex flex-col items-center lg:max-w-6xl lg:flex-row lg:justify-between">
                    <div className="flex justify-center mb-8 lg:mb-0">
                        <img
                            src={config.logo_url}
                            alt="NordVPN Logo"
                            className="h-10"
                        />
                    </div>
                    <div className="flex flex-col items-start space-y-4 text-lg text-left lg:flex-row lg:space-y-0 lg:space-x-8 lg:text-sm lg:items-center">
                        <a href="https://dcb-checkout.com/privacy-policy.html" className="text-gray-600 no-underline hover:text-blue-600">{textConfig.footer.links.privacyPolicy}</a>
                        <a href="https://dcb-checkout.com/terms-of-service.html" className="text-gray-600 no-underline hover:text-blue-600">{textConfig.footer.links.termsOfUse}</a>
                    </div>
                </div>
            </div>

            {/* Powered by Banner - Fixed on mobile, normal on desktop */}
            <div className="bg-black text-white text-center py-3 px-4 lg:relative lg:bottom-auto fixed bottom-0 left-0 right-0 z-50">
                <p className="font-semibold mb-0 text-sm">
                    Powered by <span>DCB </span><span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">CHECKOUT</span>
                </p>
            </div>
        </div>
    );
} 